import React, { useEffect, useState } from 'react';

import PageContentWrapper from '../components/pageContentWrapper';
import ManageUsersTable from './ManageUsersTable';
import ManageUsersFilter from './ManageUsersFilter';
import { BodyCard } from '../components/styledComponent';
import { getAgentsAndAccountAdmins } from '../../service/userService';
import { convertGetAgentsAndAccountAdminsResponseToTableRowData } from './responseProcessors';
import { CreateUserPath } from '../../appRoutes';
import { OrangeLinkHeader } from '../../components/OrangeLink';

import type { RowData } from '../../components/table';

const ManageUsersContainer: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const dataIndexes = {
    username: 0,
    emailAddress: 1,
    status: 2,
    role: 3,
  };

  const [data, setData] = useState<RowData[]>([]);

  const [filteredData, setFilteredData] = useState<RowData[]>([]);

  const anyString = 'Any';

  const [usernameFilter, setUsernameFilter] = useState('');
  const [emailAddressFilter, setEmailAddressFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('Active');
  const [roleFilter, setRoleFilter] = useState(anyString);
  const [clearFlag, setClearFlag] = useState(false);

  const applyFilters = () => {
    const newFilteredData = data.filter(item => {
      // this cast-through-any is to appease the dark flow typing gods
      const values = item?.values as string[];
      const matchesUsernameFilter = values?.[dataIndexes.username]
          ?.toLowerCase()
          ?.includes(usernameFilter?.toLowerCase()),
        matchesEmailAddressFilter = values?.[dataIndexes.emailAddress]
          ?.toLowerCase()
          ?.includes(emailAddressFilter?.toLowerCase()),
        matchesStatusFilter =
          values?.[dataIndexes.status] === statusFilter ||
          statusFilter === anyString,
        matchesRoleFilter =
          values?.[dataIndexes.role] === roleFilter ||
          roleFilter === anyString;
      return (
        matchesUsernameFilter &&
        matchesEmailAddressFilter &&
        matchesStatusFilter &&
        matchesRoleFilter
      );
    });
    setFilteredData(newFilteredData);
  };

  useEffect(() => {
    if (clearFlag) {
      applyFilters();
      setClearFlag(false);
    }
  }, [clearFlag]);

  useEffect(() => {
    applyFilters();
  }, [data]);

  useEffect(() => {
    getAgentsAndAccountAdmins().then(result => {
      const processedResult = convertGetAgentsAndAccountAdminsResponseToTableRowData(
        result,
      );

      setData(processedResult);
      setLoading(false);
    });
  }, []);

  const noRowsValue = 'No User Records Match Filters';

  return (
    <PageContentWrapper loading={loading} title="MANAGE USERS">
      <OrangeLinkHeader path={CreateUserPath} text="Create New User" />
      <BodyCard>
        <ManageUsersFilter
          usernameFilter={usernameFilter}
          setUsernameFilter={setUsernameFilter}
          emailAddressFilter={emailAddressFilter}
          setEmailAddressFilter={setEmailAddressFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          roleFilter={roleFilter}
          setRoleFilter={setRoleFilter}
          setClearFlag={setClearFlag}
          onSubmit={applyFilters}
        />
      </BodyCard>
      <BodyCard>
        <ManageUsersTable data={filteredData} noRowsValue={noRowsValue} />
      </BodyCard>
    </PageContentWrapper>
  );
};

export default ManageUsersContainer;
